import { useState, useEffect } from "react";
import { getBucket } from "../utilities/optimizely";

export const useExperiment = (key) => {
  const [bucket, setBucket] = useState(null);

  useEffect(() => {
    const getVariant = async () => {
      const returnedBucket = await getBucket(key);
      setBucket(returnedBucket);
    };

    getVariant();
  }, [key, setBucket]);

  return bucket;
};
